<template>
  <div>
    <b-alert 
      v-for="(proceso, index) in procesosList" 
      :key="index" show 
      :variant="getVariantCard(proceso.action)" 
      class="my-2 p-2 card-procesos"
    >

      <div class="d-flex justify-content-end align-items-center">
        <small class="text-muted">{{ proceso.action.toUpperCase() }}</small>
        <b-button 
          v-if="canEditItem(proceso)"
          variant="warning" 
          size="sm" 
          class="card-button"
          @click="onEditProceso(index)"
        >
          <i class="fa-solid fa-pen"/>
        </b-button>

        <b-button 
          v-if="canDeleteItem(proceso)"
          variant="danger" size="sm" 
          class="card-button"
          @click="onRemoveProceso(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>

        <b-button 
          v-if="proceso.action === 'eliminar'"
          variant="warning" 
          size="sm"
          class="card-button"
          @click="onRestoreItem(index)"
          title="Restaurar Item"
        >
          <i class="fa-solid fa-rotate-right"/>
        </b-button>
      </div>


      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Estado: </strong> 
        <span class="text-dark">{{ proceso.estadoProcedimiento || '-' }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Núm. de Orden: </strong> 
        <span class="text-dark">{{ proceso.numeroOrden }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Proceso: </strong> 
        <span class="text-dark">{{ proceso.procedimiento.text }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Mot. de Solicitud: </strong> 
        <span class="text-dark">{{ proceso.motivoSolicitud }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Res. Clínico: </strong> 
        <span class="text-dark">{{ proceso.resumenClinico }}</span>
      </b-row>

      <b-row v-if="proceso.justificacion" style="margin-bottom: 5px;">
        <strong class="item-label">Justificacion: </strong> 
        <span class="text-dark">{{ proceso.justificacion }}</span>
      </b-row>
      
    </b-alert>
  </div>
</template>

<script>
export default {

  name: "CardEnvioProcesos",

  props: {
    procesosList: {
      type: Array,
      default: () => []
    },

    saveInState: {
      type: Function,
      default: () => {}
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },


  methods:{

    onEditProceso(index) {
      this.navigateToQuery("editProcess", index);
    },

    async onRemoveProceso(index) {

      const result = await this.$swal({
        title: 'Eliminar Proceso Clínico',
        text: '¿Está seguro de eliminar el proceso clínico?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Eliminar',
        cancelButtonText: 'No, Cancelar',
        confirmButtonColor: '#d33',
      });

      if (!result.isConfirmed) return;
      
      if(this.procesosList[index].action !== 'crear'){
        this.procesosList[index].action = 'eliminar';
        return;
      }

      this.procesosList.splice(index, 1);
    },


    getVariantCard(action){

      const variant = action === 'registrado' 
        ? 'success'
        : action === 'editar'
          ? 'warning'
          : action === 'eliminar'
            ? 'danger'
            : 'info';

      return variant;
    },


    canEditItem(item){
      const estadoValido = item.estadoProcedimiento !== 'Incompleto' && item.estadoProcedimiento !== 'Terminada';
      return item.action !== 'eliminar' && estadoValido && !this.onlyView
    },

    canDeleteItem(item){
      const estadoValido = item.estadoProcedimiento !== 'Incompleto' && item.estadoProcedimiento !== 'Terminada';
      return item.action !== 'eliminar' && estadoValido && !this.onlyView
    },

    onRestoreItem(index){
      this.procesosList[index].action = 'registrado'
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  },
}
</script>

<style>

.card-procesos .item-label {
  width: 150px;
  margin-left: 10px;
}

.card-procesos .card-button {
  margin-left: 8px;
  padding: 5px;
}
</style>
